import { useGlobalContext } from "@/context/globalContext";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import CloseButton from "./buttons/CloseButton";
import { useOverflow } from "@/hooks/useOverflow";

const AnimatedDiv = dynamic(() => import("./Bottombar/AnimatedDiv"), {
  ssr: false,
});
const BottomBarSearch = dynamic(() => import("./Bottombar/BottomBarSearch"), {
  ssr: false,
});
const MobileSearchForm = dynamic(() => import("./Bottombar/MobileSearchForm"), {
  ssr: false,
});

const BottomContent = ({ ssr, dataHeader }) => {
  const { mobileBar, setMobileBar, bgShadow, setBgShadow } = useGlobalContext();

  const CloseAll = () => {
    setMobileBar(false);
  };

  useEffect(() => {
    setBgShadow(mobileBar);
  }, [mobileBar]);

  useEffect(() => {
    if (bgShadow === false) CloseAll();
  }, [bgShadow]);

  useOverflow(mobileBar);

  return (
    <div>
      {mobileBar == "search" ? (
        <AnimatedDiv animate={mobileBar == "search" ? "open" : "closed"}>
          <CloseButton CloseAll={CloseAll} />
          <div className="flex flex-col h-[calc(70vh)] overflow-auto">
            {mobileBar == "search" && BottomBarSearch && (
              <BottomBarSearch
                setMobileBar={setMobileBar}
                dataHeader={dataHeader}
              />
            )}
          </div>
        </AnimatedDiv>
      ) : null}
      {mobileBar == "searchform" || mobileBar == "ProductSearch" ? (
        <AnimatedDiv animate={mobileBar == "searchform" ? "open" : "closed"}>
          <CloseButton CloseAll={CloseAll} />
          <div className="flex flex-col">
            {mobileBar == "searchform" || mobileBar == "ProductSearch" ? (
              <MobileSearchForm ssr={ssr} />
            ) : null}
          </div>
        </AnimatedDiv>
      ) : null}
    </div>
  );
};

export default BottomContent;
